import React from "react";
import clsx from "clsx";

import styles from "./layout.module.scss";

type TitleContainerProps = {
	className?: string;
	children: any;
};

export const TitleContainer = ({
	children,
	className,
}: TitleContainerProps) => (
	<div className={clsx(styles.titleContainer, className)}>{children}</div>
);
